import { CreditAndCollections } from "../../../ar/src/CreditAndCollections";
import { Financials } from "../../../ar/src/Financials";
import { TableComment } from "../../../general/src/TableComment";
import { TableContact } from "../../../general/src/TableContact";
import { QuoteList } from "../../../powerbroker/src/QuoteList";
import { ProspectActionList } from "../ProspectActionList";
import { Button, Checkbox, CityState, DataHeader, DataSource, Label, Layout, Map, Panel, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutProspect extends Layout {
    accordionMap: Tabset;
    buttonAddNew: Button;
    buttonAddOrder: Button;
    buttonAddQuote: Button;
    buttonCustomerUsers: Button;
    buttonFindNear: Button;
    buttonMakeLocation: Button;
    buttonMarketPlan: Button;
    buttonSearchOrders: Button;
    checkboxIsConsignee: Checkbox;
    checkboxIsDistributionCenter: Checkbox;
    checkboxIsDropYard: Checkbox;
    checkboxIsGeocoded: Checkbox;
    checkboxIsPalletsRequired: Checkbox;
    checkboxIsShipper: Checkbox;
    checkboxIsTrailerPoolRequired: Checkbox;
    citystate1: CityState;
    citystateS: CityState;
    dataheaderProspect: DataHeader;
    label1: Label;
    labelHeaderContactEmail: Label;
    labelHeaderContactName: Textbox;
    labelHeaderContactPhone: Label;
    labelHeaderLocName: Textbox;
    layoutContactTable: TableContact;
    layoutCreditCollections: CreditAndCollections;
    layoutFinancials: Financials;
    layoutQuoteList: QuoteList;
    layoutTableActivities: ProspectActionList;
    layoutTableComment: TableComment;
    map1: Map;
    panel1: Panel;
    panel2: Panel;
    panel3: Panel;
    panelGeneral1: Panel;
    panelGeneral2: Panel;
    panelGeneral3: Panel;
    panelGeneral4: Panel;
    panelHeader: Panel;
    panelHeaderContact: Panel;
    panelHeaderProspect: Panel;
    panelSecondaryFilters: Panel;
    sourceAgencyLink: DataSource;
    sourceComments: DataSource;
    sourceContacts: DataSource;
    sourceOpportunity: DataSource;
    sourceProspect: DataSource;
    sourceProspectAction: DataSource;
    sourceSalespersonReassign: DataSource;
    switchActive: Switch;
    tabActivities: Tab;
    tabComments: Tab;
    tabContacts: Tab;
    tabCreditCollections: Tab;
    tabFinancials: Tab;
    tabGeneral: Tab;
    tabMap: Tab;
    tabOpportunities: Tab;
    tabOther: Tab;
    tabQuotes: Tab;
    tabReassignment: Tab;
    tableOpportunity: Table;
    tabset1: Tabset;
    tabsetMain: Tabset;
    tabsetMap: Tab;
    textCityState: CityState;
    textboxActivityCount: Textbox;
    textboxActivityCountSR: Textbox;
    textboxActivityStartDate: Textbox;
    textboxAddress1: Textbox;
    textboxAddress2: Textbox;
    textboxBridgeId: Textbox;
    textboxByActivity: Textbox;
    textboxByOrder: Textbox;
    textboxByRevenue: Textbox;
    textboxCategory: Textbox;
    textboxConfidenceLevel: Textbox;
    textboxConversionDate: Textbox;
    textboxDriverLoad: Textbox;
    textboxExpectedClose: Textbox;
    textboxGooglePlaceId: Textbox;
    textboxGooglePlacesSearch: Textbox;
    textboxId: Textbox;
    textboxLatitude: Textbox;
    textboxLocationId: Textbox;
    textboxLongitude: Textbox;
    textboxMainPhone: Textbox;
    textboxMarkPlanId: Textbox;
    textboxMotorCarrierId: Textbox;
    textboxName: Textbox;
    textboxNextRecCall: Textbox;
    textboxOperationsUser: Textbox;
    textboxOrderCount: Textbox;
    textboxOrderCountSR: Textbox;
    textboxOrderStartDate: Textbox;
    textboxPotential: Textbox;
    textboxPrimaryCommodityId: Textbox;
    textboxPrimaryContact: Textbox;
    textboxPrimaryTrailerType: Textbox;
    textboxProspectTypeId: Textbox;
    textboxReassignProfileId: Textbox;
    textboxRecCallDays: Textbox;
    textboxRevenue: Textbox;
    textboxRevenueSR: Textbox;
    textboxRevenueStartDate: Textbox;
    textboxSalesManagerId: Textbox;
    textboxSalesStatusId: Textbox;
    textboxSalespersonId: Textbox;
    textboxStartDate: Textbox;
    textboxTypeOf: Textbox;
    textboxWebsiteUrl: Textbox;
    textboxZoneId: Textbox;
}
